import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { BaseDataService } from '../base-data-service';
import { BaseSiteCoreAPIMapper } from './base-sitecore-api-mapper.service';
import { map } from 'rxjs/operators';
import { of } from 'rxjs';
import { GlobalVariablesService } from '../global-variables.service';

@Injectable()
export class GetCorePageDataService extends BaseDataService {
  constructor(
    protected http: HttpClient,
    protected configService: AppConfigService,
    protected sitecoreDataMapper: BaseSiteCoreAPIMapper,
    protected globalVariables: GlobalVariablesService
  ) {
    super(http, configService, globalVariables);
  }
  cachedResponse = new Map();

  getSiteCoreData(pageName) {
    if (this.cachedResponse.has(pageName)) {
      return of(this.cachedResponse.get(pageName));
    } else {
      return this.http
        .get(
          `${this.configService.config.contentServiceBaseUrl}?PageName=${pageName}`
        )
        .pipe(
          map(data => {
            let result = this.sitecoreDataMapper.mapSiteCoreData(data);
            this.cachedResponse.set(pageName, result);
            return result;
          })
        );
    }
  }
}
